import { ThemeProvider, CssBaseline } from "@mui/material"
import theme from "./theme/theme"
import "./styles/global.css"
import AppRouter from "./routes/AppRouter"
import { TenantProvider } from "./context/tenantContext"
import { NotificationProvider } from "./context/NotificationContext"

export default function App() {
  return (
    <TenantProvider>
      <NotificationProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AppRouter />
        </ThemeProvider>
      </NotificationProvider>
    </TenantProvider>
  )
}
